import { types, actions } from './requests'
export const CREATEDEPOSIT_TYPES = {
    ...types('CREATEDEPOSIT'),
}
export const CREATEDEPOSIT_ACTIONS = {
    ...actions('CREATEDEPOSIT'),
}
